import React from "react";

const CommissionMain = React.lazy(() => import("../../Commissions/CommissionMain"));

export const commissionRoutes = [
  {
    path: "/commission",
    Component: CommissionMain,
    rolename: "Accounts_Dashboard",
  },
  {
    path: "/commission/dashboard",
    Component: CommissionMain,
    rolename: "Accounts_Dashboard",
  },
  {
    path: "/commission/developers",
    Component: CommissionMain,
    rolename: "Accounts_Dashboard",
  },
  {
    path: "/commission/aging",
    Component: CommissionMain,
    rolename: "Accounts_Dashboard",
  },
  {
    path: "/commission/lifecycle",
    Component: CommissionMain,
    rolename: "Accounts_Dashboard",
  },
  {
    path: "/commission/payouts",
    Component: CommissionMain,
    rolename: "Accounts_Dashboard",
  },
  {
    path: "/commission/reconciliation",
    Component: CommissionMain,
    rolename: "Accounts_Dashboard",
  },
  {
    path: "/commission/branches",
    Component: CommissionMain,
    rolename: "Accounts_Dashboard",
  },
  {
    path: "/commission/audit",
    Component: CommissionMain,
    rolename: "Accounts_Dashboard",
  },
];
